import NumberFormat from 'react-number-format'

import { Flex, Text, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const NumberInputCell = ({
  getValue,
  table,
  row: { index: rowIndex },
  column: { id: columnId },
  extraDisable = false,
  handlePaste = () => {},
  decimalScale = 0,
}) => {
  const [localValue, setLocalValue] = useState(getValue())
  const isDisabled = table.options.meta?.disabled || extraDisable

  useEffect(() => {
    if (getValue()) {
      setLocalValue(getValue)
    }
  }, [getValue])
  const onChange = ({ value }) => {
    if (value) {
      setLocalValue(value)
    }
  }

  const onBlur = () => {
    table.options.meta?.updateData(rowIndex, columnId, localValue)
  }

  const onPaste = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData
    const pastedData = clipboardData.getData('Text')

    e.preventDefault()
    e.stopPropagation()

    handlePaste(pastedData, { rowIndex, columnId })
  }

  if (isDisabled) {
    return <Text>{localValue}</Text>
  }
  return (
    <Input
      as={NumberFormat}
      thousandSeparator
      allowNegative={false}
      decimalScale={decimalScale}
      value={localValue}
      onValueChange={onChange}
      onBlur={onBlur}
      onPaste={onPaste}
    ></Input>
  )
}

export default NumberInputCell
